import { render, staticRenderFns } from "./ResourceContent.vue?vue&type=template&id=790e4904&scoped=true&"
import script from "./ResourceContent.js?vue&type=script&lang=js&"
export * from "./ResourceContent.js?vue&type=script&lang=js&"
import style0 from "./ResourceContent.vue?vue&type=style&index=0&id=790e4904&prod&scoped=true&lang=css&"
import style1 from "./ResourceContent.vue?vue&type=style&index=1&id=790e4904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790e4904",
  null
  
)

export default component.exports